import classnames from "classnames";
import styled from "styled-components";

import {
  background,
  ThemeProps,
  ThemeWrapperProps
} from "features/common/themes";

import { Size, SIZES } from "./consts";
import styles from "./ProgressBar.module.scss";

const DEFAULT_ANIMATION_DURATION = 300;

type Props = {
  progress: number;
  loading?: boolean;
  size?: Size;
  noTheme?: boolean;
  color?: string;
  animationDuration?: number;
};

type ComponentThemeProps = ThemeProps & {
  noTheme?: boolean;
  color?: string;
};

const ThemeWrapper = styled.div<ThemeWrapperProps>`
  ${({ theme, noTheme, color }: ComponentThemeProps) => {
    if (noTheme) {
      return null;
    }

    if (color) {
      return `
  .${styles.bar} {
     ${background(color)}
  }
  `;
    }

    return `
  .${styles.bar} {
     ${background(theme["primary-high-content"])}
  }
  `;
  }}
`;

export default function ProgressBar({
  progress = 0,
  size,
  loading,
  noTheme,
  color,
  animationDuration = DEFAULT_ANIMATION_DURATION
}: Props) {
  return (
    <ThemeWrapper
      className={styles.themeWrapper}
      // @ts-ignore
      noTheme={noTheme}
      color={color}
    >
      <div
        className={classnames(styles.wrapper, {
          [styles.sizeSmall]: size === SIZES.SMALL || !size,
          [styles.sizeMedium]: size === SIZES.MEDIUM,
          [styles.sizeLarge]: size === SIZES.LARGE,
          [styles.sizeXLarge]: size === SIZES.XLARGE,
          [styles.loading]: loading
        })}
      >
        <div
          style={{
            width: `${loading ? 0 : progress.toFixed(0)}%`,
            transition: `width ${animationDuration}ms ease`
          }}
          className={classnames(styles.bar, {
            [styles.sizeSmall]: size === SIZES.SMALL || !size,
            [styles.sizeMedium]: size === SIZES.MEDIUM,
            [styles.sizeLarge]: size === SIZES.LARGE,
            [styles.sizeXLarge]: size === SIZES.XLARGE
          })}
        />
      </div>
    </ThemeWrapper>
  );
}
